import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';
import Box from '@components/layout/box';
import BoxHeader from '@components/layout/box-header';

const OwnershipPublished = () => {
  return (
    <Box noBorderTop noBorderBottom>
      <BoxHeader
        title={
          <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.PUBLISHED.TITLE" />
        }
        text={
          <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.PUBLISHED.TEXT" />
        }
        noMargin
      />
      <Image src="./static/published-ownership.png" />
    </Box>
  );
};

export default OwnershipPublished;

const Image = styled.img`
  width: 100%;
  max-width: 248px;
  display: block;
  margin: 10px auto 5px 0px;
`;
